import { z } from "zod";
import { localizeField } from "~/core/api/Sanity/localize";
import { AVAILABLE_LOCALES } from "~/core/locale";
import { LogePage } from "../Domain/LogePage";
import { LogePagesPayloadSchema } from "./logePagePayloadSchema";

type LogePagePayloadItem = z.infer<typeof LogePagesPayloadSchema>[number];

export function mapToLogePageDomain(
  payloadItem: LogePagePayloadItem,
  locale: AVAILABLE_LOCALES,
): LogePage {
  return {
    seoSlug: payloadItem.seoSlug.current,
    gogaillePlacesAddressDetails: localizeField(
      payloadItem.gogaillePlacesAddressDetails,
      locale,
    ),
    gogaillePlacesDistancesDetails: localizeField(
      payloadItem.gogaillePlacesDistancesDetails,
      locale,
    ),
    gogaillePlacesParkingsDetails: localizeField(
      payloadItem.gogaillePlacesParkingsDetails,
      locale,
    ),
    accessibility: {
      reducedMobilityRooms: payloadItem.accessibility.reducedMobilityRooms,
      elevator: payloadItem.accessibility.elevator,
      stairliftPlatform: payloadItem.accessibility.stairliftPlatform,
    },
    visibility: payloadItem.visibility.value,
    logo: payloadItem.logo ?? null,
    intro: payloadItem.intro ? localizeField(payloadItem.intro, locale) : null,
    features: payloadItem.features
      ? {
          terrace: payloadItem.features.terrace ?? false,
          bikePark: payloadItem.features.bikePark ?? false,
          garden: payloadItem.features.garden ?? false,
          carPark: payloadItem.features.carPark ?? false,
        }
      : null,
    loge: {
      sanityId: payloadItem.loge._id,
      pmsId: payloadItem.loge.pmsId.current,
      name: payloadItem.loge.name,
      gallery: payloadItem.loge.gallery ?? null,
      building: {
        address: {
          line1: payloadItem.loge.building.address.line1,
          line2: payloadItem.loge.building.address.line2 ?? null,
          postalCode: payloadItem.loge.building.address.postalCode,
          city: payloadItem.loge.building.address.city,
          coordinate: {
            latitude: payloadItem.loge.building.address.coordinate.lat,
            longitude: payloadItem.loge.building.address.coordinate.lng,
          },
        },
      },
    },
    houseKeeperEditorial: payloadItem.houseKeeperEditorial
      ? {
          photo: payloadItem.houseKeeperEditorial.photo?.asset?.url
            ? {
                asset: {
                  url: payloadItem.houseKeeperEditorial.photo.asset.url,
                  metadata:
                    payloadItem.houseKeeperEditorial.photo.asset.metadata,
                },
              }
            : null,
          text: payloadItem.houseKeeperEditorial.text
            ? localizeField(payloadItem.houseKeeperEditorial.text, locale)
            : null,
          additionalInformation: payloadItem.houseKeeperEditorial
            .additionalInformation
            ? localizeField(
                payloadItem.houseKeeperEditorial.additionalInformation,
                locale,
              )
            : null,
        }
      : null,
  };
}
